import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * Update patient profile default session type in batch
 */
export default async function batchPutPatientProfile(
  oldDefaultSessionType: string,
  nextDefaultSessionType: string,
): Promise<void> {
  const res = await fetchOrchidAPI(
    `/api/users/v1/patient_profile/bulk-update`,
    {
      method: "PUT",
      body: JSON.stringify({
        next_default_session_type: nextDefaultSessionType,
        from_default_session_type: oldDefaultSessionType,
      }),
    },
  );
  if (!res.ok) {
    throw new Error(getErrorDetail(await res.text()));
  }
  return;
}
